module.exports = __webpack_public_path__ + "static/img/nginx.8dbd7777.png";